import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsInt, IsPositive, Min } from 'class-validator';
import { IsUndefinable } from '../validator';
export class RequestPaginationDto {
    constructor() {
        this.offset = 0;
        this.limit = 10;
    }
}
__decorate([
    Expose(),
    Type(() => Number),
    IsInt(),
    Min(0),
    IsUndefinable(),
    ApiPropertyOptional({ type: () => Number, default: 0 }),
    __metadata("design:type", Number)
], RequestPaginationDto.prototype, "offset", void 0);
__decorate([
    Expose(),
    Type(() => Number),
    IsInt(),
    IsPositive(),
    IsUndefinable(),
    ApiPropertyOptional({ type: () => Number, default: 10 }),
    __metadata("design:type", Number)
], RequestPaginationDto.prototype, "limit", void 0);
//# sourceMappingURL=RequestPaginationDto.js.map